import { lazy } from 'react';
import appmaker from '@appmaker/core/index';
import { ChartPieIcon } from '@heroicons/react/solid';
import { useUser } from '@appmaker/core/store/user';

const Home = lazy(() => import('./routes/Home'));

const AdminAnalytics = () => {
	const { isAdmin } = useUser();
	if (!isAdmin) {
		return <p className="p-6 text-sm text-gray-500">Analytics is currently available to admins only.</p>;
	}
	return <Home />;
};

const plugin = {
	id: '@appmaker/firebase-analytics',
	name: 'Analytics',
	activate: () => {
		appmaker.registerRoute({
			routeName: '/analytics',
			component: AdminAnalytics,
		});

		/**
		 * Menu Items
		 */
		appmaker.registerSideBarMenu(
			{
				name: 'Analytics',
				routeName: '/analytics',
				icon: ChartPieIcon,
				adminOnly: true,
				addTracker: {
					eventName: 'analytics_page_clicked',
				},
			},
			8.5 // Immediately after App Builds (priority 8).
		);
	},
};

export default plugin;
